import Vue from "vue";
import Vuex from "vuex";

const Document = {
  namespaced: true,
  state: {
    documents: [],
    documentSelected: {},
    missingDocuments: [],
    typeDocuments: null,
    pieces: [],
  },
  actions: {
    sendDocument(context, payload) {
      let document = payload;
      let skipGlobalSpinner = false;

      if (payload && payload.file != null) {
        document = payload.file;
        skipGlobalSpinner = payload.skipGlobalSpinner === true;
      }

      let formData = new FormData();
      formData.append("file", document);
      formData.append("requestId", document.requestId);
      formData.append("stdUserId", document.stdUserId);
      formData.append("typeDocumentId", document.typeDocumentId);

      return Vue.axios
        .post(window.urlapi + "document", formData, {
          headers: { "Content-Type": "multipart/form-data" },
          skipGlobalSpinner,
        })
        .then((response) => {
          if (response.data.success === false) {
            const message =
              response.data.message || "Erreur lors de l'envoi du document.";
            return Promise.reject(new Error(message.toString()));
          }
          return response;
        });
    },

    getDocuments(context, requestId) {
      return new Promise((resolve, reject) => {
        Vue.axios
          .get(window.urlapi + "request/" + requestId)
          .then((response) => {
            let result = response.data.data.documents;
            context.commit("GETDOCUMENTS", response.data.data.documents);
            resolve(result);
          });
      });
    },

    getDocumentsFromCerfa(context, typeCerfa) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(window.urlapi + "typedocument").then((response) => {
          let result = response.data.data;
          context.commit("GETTYPEDOCUMENTS", result);
          resolve();
        });
      });
    },

    getMissingDocuments(context, request) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(window.urlapi + "typedocument").then((response) => {
          if (typeof request.missingDocuments !== "undefined")
            for (let i = response.data.data.length; i--; ) {
              if (
                !request.missingDocuments.includes(
                  response.data.data[i].id.toString()
                )
              ) {
                response.data.data.splice(i, 1);
              }
            }

          let documents = [];

          for (let i = 0; i < response.data.data.length; i++) {
            documents.push({
              file: null,
              typeDocument: response.data.data[i],
            });
          }

          context.commit("GETMISSINGDOCUMENTS", documents);
          resolve();
        });
      });
    },

    removeDocument(context, iddoc) {
      return new Promise((resolve) => {
        Vue.axios.delete(window.urlapi + "document/"+ iddoc).then((response) => {
          if (response.data.success == true) {
            Vue.prototype.$awn.success(response.data.message.toString());
          }
          resolve(response);
        });
      });
    },
  },
  mutations: {
    GETDOCUMENTS: (state, documents) => {
      state.documents = documents;
    },
    GETMISSINGDOCUMENTS: (state, missingDocuments) => {
      state.missingDocuments = missingDocuments;
    },
    GETTYPEDOCUMENTS: (state, typeDocuments) => {
      state.typeDocuments = typeDocuments;
    },
  },
  getters: {
    documents: (state) => {
      return state.documents;
    },
    typeDocuments: (state) => {
      return state.typeDocuments;
    },
    missingDocuments: (state) => {
      return state.missingDocuments;
    },
    countdocument: (state) => {
      return state.documents.length;
    },
  },
  modules: {},
};

export default Document;